// MyShop Admin UI Components
// Pure CSS Design System (No Vuetify)

// Base Components
import BaseButton from './BaseButton.vue'
import IconButton from './IconButton.vue'
import BaseInput from './BaseInput.vue'
import BaseTextarea from './BaseTextarea.vue'
import BaseSelect from './BaseSelect.vue'
import BaseSwitch from './BaseSwitch.vue'
import BaseCard from './BaseCard.vue'
import BaseDialog from './BaseDialog.vue'
import BaseCheckbox from './BaseCheckbox.vue'
import BaseChip from './BaseChip.vue'
import BaseTable from './BaseTable.vue'
import BaseDivider from './BaseDivider.vue'
import BaseFormGroup from './BaseFormGroup.vue'
import BaseAutocomplete from './BaseAutocomplete.vue'
import BasePagination from './BasePagination.vue'

// Layout Components
import AppBar from '../layout/AppBar.vue'
import NavDrawer from '../layout/NavDrawer.vue'
import NavList from '../layout/NavList.vue'
import NavListItem from '../layout/NavListItem.vue'
import NavListGroup from '../layout/NavListGroup.vue'
import NavListSubheader from '../layout/NavListSubheader.vue'

export {
  // Base Components
  BaseButton,
  IconButton,
  BaseInput,
  BaseTextarea,
  BaseSelect,
  BaseSwitch,
  BaseCard,
  BaseDialog,
  BaseCheckbox,
  BaseChip,
  BaseTable,
  BaseDivider,
  BaseFormGroup,
  BaseAutocomplete,
  BasePagination,

  // Layout Components
  AppBar,
  NavDrawer,
  NavList,
  NavListItem,
  NavListGroup,
  NavListSubheader
}

// Default export for plugin-style registration
export default {
  install(app) {
    // Base Components
    app.component('BaseButton', BaseButton)
    app.component('IconButton', IconButton)
    app.component('BaseInput', BaseInput)
    app.component('BaseTextarea', BaseTextarea)
    app.component('BaseSelect', BaseSelect)
    app.component('BaseSwitch', BaseSwitch)
    app.component('BaseCard', BaseCard)
    app.component('BaseDialog', BaseDialog)
    app.component('BaseCheckbox', BaseCheckbox)
    app.component('BaseChip', BaseChip)
    app.component('BaseTable', BaseTable)
    app.component('BaseDivider', BaseDivider)
    app.component('BaseFormGroup', BaseFormGroup)
    app.component('BaseAutocomplete', BaseAutocomplete)
    app.component('BasePagination', BasePagination)

    // Layout Components
    app.component('AppBar', AppBar)
    app.component('NavDrawer', NavDrawer)
    app.component('NavList', NavList)
    app.component('NavListItem', NavListItem)
    app.component('NavListGroup', NavListGroup)
    app.component('NavListSubheader', NavListSubheader)
  }
}
